import { useMutation } from "react-query"
import api from "../client"
import { AuthRegistrationPayload, AuthRegistrationResponseData } from "../types/auth"

const postData = async (payload: AuthRegistrationPayload): Promise<AuthRegistrationResponseData> => {
    try {
        const { data } = await api.post<AuthRegistrationResponseData>(
            "/users/register",
            payload
        )
        return data
    } catch ({ response: { data } }) {
        return data as AuthRegistrationResponseData
    }
}

export const useAuthRegistration = () => {
    return useMutation((payload: AuthRegistrationPayload) => {
        return postData(payload)
    })
}
